export const NEARBY_MAX_KM = 50;

export function hospitalId(h) {
  return h?.hospitalId || h?.id || '';
}

export function hospitalLatLng(h) {
  const lat = Number(h?.latitude ?? h?.lat);
  const lng = Number(h?.longitude ?? h?.lng);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || (lat === 0 && lng === 0)) return null;
  return { lat, lng };
}

export function matchesHospitalFilter(h, filter) {
  const t = (h?.type || '').toLowerCase().trim();
  switch (filter) {
    case 'government':
      return t === 'government' || t === 'govt';
    case 'private':
      return !t || t === 'private';
    case 'trust':
      return h?.isTrusted === true
        || ['trust', 'government', 'govt'].includes(t);
    case 'ntr':
      return h?.hasNtrVaidyaSeva === true;
    default:
      return true;
  }
}
